import { Injectable } from '@angular/core';
import { LoggerService } from 'angular-lib';

@Injectable()
export class LoaderService {
    public text: string;
    private status: string = 'inactive';
    public icon: string = 'flash';

    public show() {
        this.status = 'active';
        LoggerService.info('LOADER ACTIVATED');
    }

    public isActive() {
        return this.status === 'active';
    }

    /**
     *
     * @param delay millisecond
     * @param icon string
     * @param message string
     */
    public hide(delay: number = null, icon: string = null, message: string = null) {
        if (icon) {
            this.icon = icon
        }
        if (message) {
            this.text = message
        }
        if (delay) {
            setTimeout((e) => {
                this.status = 'inactive';
                LoggerService.info('LOADER HIDDEN');
            }, delay);
        } else {
            this.status = 'inactive';
            LoggerService.info('LOADER HIDDEN');
        }
    }

    public reset() {
        this.icon = 'flash';
        this.text = null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/services/loader.service.ts